export default __webpack_public_path__ + "static/media/demo_03.06110832.png";